import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { NextRewardProgress } from "@/components/TodayForYou";

const PAGES = ["/dashboard", "/spiele", "/punkte-sammeln", "/community-aufgabe", "/haustier", "/lotto", "/teams"];

export function NextRewardStrip() {
  const { pathname } = useLocation();
  const [d, setD] = useState(null);
  const show = PAGES.includes(pathname) && pathname !== "/punkte-sammeln";
  useEffect(() => {
    if (!show) return undefined;
    const load = () => api.get("/next-reward").then(({ data }) => setD(data)).catch(() => {});
    load();
    window.addEventListener("points-awarded", load);
    return () => window.removeEventListener("points-awarded", load);
  }, [show, pathname]);
  if (!show || !d?.next) return null;
  return <div className="max-w-2xl mx-auto mb-4" data-testid="next-reward-strip"><NextRewardProgress next={d.next} points={d.points} compact /></div>;
}
